<template>
  <div class="arrow-breadcrumb">
    <a href="javascript:void(0)">
      <div
        v-if="!isMobile"
        class="item h-100 d-flex align-items-center justify-content-center"
      >
        <h4>{{ title }}</h4>
      </div>
    </a>
    <a
      v-if="isVoloHotel || isExperience"
      href="javascript:void(0)"
      :class="activeVoliHotels ? 'active' : ''"
      @mouseover="isHover = 1"
      @mouseleave="isHover = 0"
      @click="onOpen('initial')"
    >
      <div class="item">
        <h6
          v-if="hasTour"
          :class="`adj-icon before-icon-volo-hotel-attivita after-icon-step-checked nowrap ${
            isHover === 1 || activeVoliHotels ? 'white' : 'blue'
          }`"
        >
          {{ isMobile ? "" : "VOLI A/R + HOTEL + TOUR" }}
        </h6>
        <h6
          v-else
          :class="`adj-icon before-icon-volo-hotel-attivita after-icon-step-checked nowrap ${
            isHover === 1 || activeVoliHotels ? 'white' : 'blue'
          }`"
        >
          {{ isMobile ? "" : "VOLI A/R + HOTEL" }}
        </h6>
        <div style="width: 36px; height: 36px">
          <img
            src="../../../assets/images/svg/blue/icone_check.svg"
            width="36px"
          />
        </div>
      </div>
    </a>
    <a
      v-if="isTour"
      href="javascript:void(0)"
      class="active"
      @mouseover="isHover = 1"
      @mouseleave="isHover = 0"
      @click="onOpen('initial')"
    >
      <div class="item">
        <h6 class="adj-icon before-icon-volo-hotel-attivita white nowrap">
          {{ isMobile ? "" : "VOLI A/R + TOUR" }}
        </h6>
        <div style="width: 36px; height: 36px">
          <img
            class="icon-blue"
            src="../../../assets/images/svg/blue/icone_check.svg"
            width="36px"
          />
        </div>
      </div>
    </a>
    <a
      v-if="(isVoloHotel || isExperience) && servizi && servizi.length > 0"
      href="javascript:void(0)"
      :class="
        (activeAttivita ? 'active ' : '') +
        (completedAttivita ? 'completed' : '')
      "
      @mouseover="isHover = 2"
      @mouseleave="isHover = 0"
      @click="onOpen('serviceId')"
    >
      <div class="item">
        <h6
          :class="`adj-icon before-icon-attivita ${
            isHover === 2 || activeAttivita ? 'white' : 'blue'
          }`"
        >
          {{ isMobile ? "" : "attività" }}
        </h6>
        <div style="width: 36px; height: 36px">
          <img
            v-if="completedAttivita"
            src="../../../assets/images/svg/blue/icone_check.svg"
            width="36px"
          />
        </div>
      </div>
    </a>
    <a
      v-if="isShowTransfer"
      href="javascript:void(0)"
      :class="
        (activeTrasferimenti ? 'active ' : '') +
        (completedTrasferimenti ? 'completed' : '')
      "
      @mouseover="isHover = 3"
      @mouseleave="isHover = 0"
      @click="onOpen('trasferimentiId')"
    >
      <div class="item">
        <h6
          :class="`adj-icon before-icon-trasferimento ${
            isHover === 3 || activeTrasferimenti ? ' white' : 'blue'
          }`"
        >
          {{ isMobile ? "" : "trasferimenti" }}
        </h6>
        <div style="width: 36px; height: 36px">
          <img
            v-if="completedTrasferimenti"
            src="../../../assets/images/svg/blue/icone_check.svg"
            width="36px"
          />
        </div>
      </div>
    </a>
    <a
      id="completaPreventivoTop"
      href="javascript:void(0)"
      class="active orange"
      @click="onOpen('completaId')"
    >
      <div class="item">
        <h6 class="adj-icon before-icon-completa-preventivo white m-0 mr-2">
          completa
        </h6>
        <img
          v-if="!isMobile"
          src="../../../assets/images/svg/white/icone_arrow-3.svg"
          width="14px"
        />
      </div>
    </a>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  PRODUCT_VOLO_HOTEL,
  PRODUCT_TOUR,
  PRODUCT_EXPERIENCE,
} from "../../../types/products";
import AnalyticEvents from "../../common/AnalyticEvents";
import MobileDetector from "../../common/MobileDetector";

export default {
  name: "ArrowBreadcrumbs",
  mixins: [AnalyticEvents, MobileDetector],
  props: {
    title: String,
  },
  data() {
    return {
      isHover: 0,
    };
  },
  computed: {
    step() {
      return this.getVariableStep();
    },
    activeVoliHotels() {
      return this.step < 3 || this.step === 5; // tour
    },
    activeAttivita() {
      return this.step === 3;
    },
    activeTrasferimenti() {
      return this.step === 4;
    },
    isVoloHotel() {
      return this.product === PRODUCT_VOLO_HOTEL;
    },
    isTour() {
      return this.product === PRODUCT_TOUR;
    },
    isExperience() {
      return this.product === PRODUCT_EXPERIENCE;
    },
    isShowTransfer() {
      return (
        !this.isTour ||
        (this.isTour &&
          this.getListaTrasferimenti().length > 0 &&
          this.tour.anagrafica.config.isTrasferimentoIncluso)
      );
    },
    product() {
      return this.getSearch().product;
    },
    hasTour() {
      return this.tour.detailResponses.length > 0;
    },
    tour() {
      return this.getItinerario().tour;
    },
    completedAttivita() {
      return this.getServiziSelected().length > 0;
    },
    completedTrasferimenti() {
      return this.getTrasferimentiSelected().length > 0;
    },
    servizi() {
      return this.getListaServizi();
    },
  },
  methods: {
    ...mapGetters([
      "getListaServizi",
      "getVariableStep",
      "getSearch",
      "getItinerario",
      "getServiziSelected",
      "getTrasferimentiSelected",
      "getListaTrasferimenti",
      "getSpeseAccessorie",
    ]),
    onOpen(id) {
      if (id === "initial") {
        if (this.isTour) {
          this.trackBreadcrumbTour();
        } else if (this.isExperience) {
          this.trackBreadcrumbExperience();
        } else {
          this.trackBreadcrumbVoloHotel();
        }
      }
      if (id === "serviceId") {
        this.trackBreadcrumbAttivita();
      }
      if (id === "trasferimentiId") {
        this.trackBreadcrumbTrasferimenti();
      }
      if (id === "completaId") {
        this.trackBreadcrumbCompleta();
      }
      this.$emit("open", id);
    },
  },
};
</script>
<style scoped>
.adj-icon::before {
  position: absolute;
  margin-top: -5px;
}
</style>



// WEBPACK FOOTER //
// src/front/components/widgets/common/ArrowBreadcrumbs.vue